import {Component, Input} from '@angular/core';

export enum EnergyLabels {
  AAAAAA = "A+++++",
  AAAAA = "A++++",
  AAAA = "A+++",
  AAA = "A++",
  AA = "A+",
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  G = "G"
}

const ENERGY_LABELS_BEST_TO_WORST = Object.values(EnergyLabels).filter((v) => isNaN(Number(v)));

function normalizedEnergyLabel(label: string | null | undefined): string | null {
  const normalized = label?.trim();
  return normalized ? normalized : null;
}

export function bestEnergyLabel(...labels: (string | null | undefined)[]): string | null {
  return labels
    .map(normalizedEnergyLabel)
    .filter((label): label is string => !!label)
    .sort((a, b) => energyLabelRank(a) - energyLabelRank(b))[0] || null;
}

export function bestLocationEnergyLabel(location: {
  info?: {energyLabel?: string | null},
  refdata?: {energyLabel?: string | null}
} | null | undefined): string | null {
  return bestEnergyLabel(location?.info?.energyLabel, location?.refdata?.energyLabel);
}

export function energyLabelRank(label: string): number {
  const index = ENERGY_LABELS_BEST_TO_WORST.indexOf(label as EnergyLabels);
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
}

@Component({
  selector: 'app-energy-label',
  templateUrl: './energy-label.component.html',
  styleUrls: ['./energy-label.component.scss']
})
export class EnergyLabelComponent {
  @Input() label: EnergyLabels | string | null;

  get cssClass() {
    return (this.label || '').replace(/\+/g, "A").substring(0, 4);
  }
}
